import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { HttpResponse } from "@angular/common/http";
import { PlanService } from "../plan.service";
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
// import Swal from "sweetalert2";
@Component({
  selector: 'app-add-plan',
  templateUrl: './add-plan.component.html',
  styleUrls: ['./add-plan.component.scss']
})
export class AddPlanComponent implements OnInit {

  planForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  desciptionName: string;
  planRequest = {
    title: null,
    subTitle: null,
    price: null,
    featureList: [],
    sortOrder: null
  }
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: PlanService
  ) { }

  ngOnInit() {
    this.initialiseForms();
    this.planForm.reset();
  }

  AddFeature() {

    this.featureList.push(this.planForm.value.desciptionName.trim())
    if (this.featureList.length > 0) {
      this.showDesciptionError = false;
      this.planForm.controls['desciptionName'].setValue(" ");
    }
  }

  initialiseForms() {
    this.planForm = this.fb.group({
      title: ["", [Validators.required]],
      subTitle: ["", [Validators.required]],
      desciptionName: ["", [Validators]],
      price: [, [Validators.required]],
      sortOrder: [, [Validators.required]],

    });
  }

  drop(event: CdkDragDrop<string[]>) {

    if (event.isPointerOverContainer == false) {

      let tempValue = this.featureList[event.currentIndex];
      this.planForm.controls['desciptionName'].setValue(tempValue.description);
      this.featureList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.featureList, event.previousIndex, event.currentIndex);
  }
  Addplan() {
    this.formSubmitted = true;
    if (this.planForm.valid) {
      this.featureList.forEach((element, index) => {
        this.finalFeatureList.push({ description: element, sortOrder: index });
      });
      this.planRequest.title = this.planForm.value.title;
      this.planRequest.subTitle = this.planForm.value.subTitle;
      this.planRequest.price = this.planForm.value.price;
      this.planRequest.sortOrder = this.planForm.value.sortOrder;
      this.planRequest.featureList = this.finalFeatureList;
      this.PlanService.saveplan(this.planRequest).subscribe(data => {
        if ((data["message"] = "Success")) {
          Swal.fire("Success", "plan Added successfully!", "success");

          this.router.navigate(["/main/plan-management/view-plan"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }




  }
  resetFeature() {
    this.featureList = [];
    this.planForm.controls['desciptionName'].setValue(" ");
    this.showDesciptionError = true;
  }
  cancel() {
    this.router.navigate(["/main/plan-management/view-plan"]);
  }
}

